module.exports = __webpack_public_path__ + "img/xiadanyouhui.1536f918.png";